// extracted by extract-css-chunks-webpack-plugin
module.exports = {"noProducts":"noProducts_M3dEt hidden text-xs md_block","noProductsTitle":"noProductsTitle_v+Eca text-lg font-openSans"};